import { AtomicBlockUtils, EditorState, Modifier, RichUtils } from 'draft-js';

import { TEXT_COLORS } from './constants';
import copyManager from './copyManager';

export function addEquation(editorState, isBlock, cb) {
  const contentState = editorState.getCurrentContent();
  const contentStateWithEntity = contentState.createEntity('EQUATION', 'IMMUTABLE', { latex: '', init: true });
  const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  let newEditorState = null;
  if (isBlock) {
    newEditorState = EditorState.set(editorState, { currentContent: contentStateWithEntity });
    newEditorState = AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, ' ');
  } else {
    const contentStateWithEntityText = Modifier.insertText(
      contentStateWithEntity,
      editorState.getSelection(),
      ' ',
      null,
      entityKey,
    );
    newEditorState = EditorState.set(editorState, { currentContent: contentStateWithEntityText });
  }
  cb(newEditorState);
}

export function copySelection(editorState, cb) {
  const selection = editorState.getSelection();
  copyManager.addSelectionToClipboard(editorState);
  // updates selection highlighting to reflect the actual copied content (full block, no partial selection copy)
  cb(
    EditorState.forceSelection(
      editorState,
      selection.merge(
        selection.getIsBackward() ?
          {
            focusOffset: 0,
            anchorOffset: editorState.getCurrentContent().getBlockForKey(selection.getAnchorKey()).getLength(),
          }
        : {
            focusOffset: editorState.getCurrentContent().getBlockForKey(selection.getFocusKey()).getLength(),
            anchorOffset: 0,
          },
      ),
    ),
  );
}

export function pasteContent(editorState, cb) {
  cb(copyManager.insertClipboardData(editorState));
}

export function toggleInlineStyle(editorState, inlineStyle) {
  const selection = editorState.getSelection();
  const currentStyle = editorState.getCurrentInlineStyle();
  let currentContent = editorState.getCurrentContent();

  MUTUALLY_EXCLUSIVE_STYLES.forEach(styles => {
    if (styles.includes(inlineStyle)) {
      styles.forEach(style => {
        if (style !== inlineStyle) {
          if (selection.isCollapsed()) {
            if (currentStyle.has(style)) editorState = RichUtils.toggleInlineStyle(editorState, style);
          } else {
            currentContent = Modifier.removeInlineStyle(currentContent, selection, style);
          }
        }
      });
      editorState = EditorState.set(editorState, { currentContent });
    }
  });

  return RichUtils.toggleInlineStyle(editorState, inlineStyle);
}

const MUTUALLY_EXCLUSIVE_STYLES = [['SUP', 'SUB'], TEXT_COLORS.map(c => c.style)];

export function getSelectedEntity(editorState) {
  const contentState = editorState.getCurrentContent();
  const selection = editorState.getSelection();
  const block = contentState.getBlockForKey(selection.getStartKey());
  if (!block) return;
  const entityKey = block.getEntityAt(selection.getStartOffset());
  if (!entityKey) return;
  const entity = contentState.getEntity(entityKey);
  if (!entity) return;
  return { entity, key: entityKey };
}
